class AvailabilityDialog extends DrawerDialog {
  constructor() {
    super();

    this.optionButtons = this.querySelectorAll(".option-value");
    this.variantStores = this.querySelectorAll(".variant-stores");
    this.optionValues = this.querySelectorAll(".option-values");
    this.selectedOptions = {
      Option1: this.getOptionValue(0),
      Option2: this.getOptionValue(1),
    };
    this.handleClick = this.handleClick.bind(this);
  }

  getOptionValue = (index) => {
    const node = this.optionValues[index];
    return (
      node?.querySelector("[active]")?.dataset?.optionValue ||
      node?.firstChild?.dataset?.optionValue
    );
  };

  handleClick(event) {
    const button = event.currentTarget;
    const optionName = button.closest(".product-option").dataset.optionName;
    const optionValue = button.dataset.optionValue;

    this.selectedOptions[optionName] = optionValue;

    const buttonsInGroup = button
      .closest(".option-values")
      .querySelectorAll(".option-value");
    buttonsInGroup.forEach((btn) => btn.removeAttribute("active"));
    button.setAttribute("active", "");

    this.updateVariantAvailability();
  }

  updateVariantAvailability() {
    this.variantStores.forEach((store) => {
      store.removeAttribute("active");
    });

    this.variantStores.forEach((store) => {
      const variantOption1 = store.dataset.option1;
      const variantOption2 = store.dataset.option2;

      const option1Matches =
        !this.selectedOptions["Option1"] ||
        this.selectedOptions["Option1"] === variantOption1;
      const option2Matches =
        !this.selectedOptions["Option2"] ||
        this.selectedOptions["Option2"] === variantOption2;

      if (option1Matches && option2Matches) {
        store.setAttribute("active", "");
      } else {
        store.removeAttribute("active");
      }
    });
  }

  connectedCallback() {
    this.optionButtons.forEach((button) => {
      button.addEventListener("click", this.handleClick);
    });

    this.updateVariantAvailability();
  }

  disconnectedCallback() {
    this.optionButtons.forEach((button) => {
      button.removeEventListener("click", this.handleClick);
    });
  }
}

customElements.define("availability-dialog", AvailabilityDialog);
